<template>
  <footer class="new_footer_area bg_color">
    <div class="footer_bottom">
      <footer class="footer-main">
        <div class="footer-container">
          <div class="footer-left">
            Copyright Datatex Dynamics &copy; 1994 – {{ currentYear }}. All
            rights reserved.
          </div>
          <div class="footer-right">
            <a
              href="/Privacy Notice 202503.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-link"
              >Privacy Policy</a
            >
            <br />
            <a href="#" @click.prevent="openModal('terms')" class="footer-link"
              >Terms and Conditions</a
            >
            <br />
            <a
              href="#"
              @click.prevent="openModal('promotion')"
              class="footer-link"
              >Promotion of Access to Information Act</a
            >
          </div>
        </div>
      </footer>

      <!-- Terms and Conditions Modal -->
      <div v-if="showTermsModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <h3>Terms and Conditions</h3>
          <br />
          <div
            class="scroll-container"
            @scroll="onScroll('terms')"
            style="max-height: 50vh"
          >
            <p>
              This software and documentation constitute an unpublished work and
              contain valuable trade secrets and proprietary information
              belonging to Datatex. None of the foregoing material may be
              copied, duplicated or disclosed without the express written
              permission of Datatex.
            </p>
            <p>
              Datatex does not warrant that the operation of Datatex Dynamics
              applications will be uninterrupted or error free.
            </p>
            <p>
              <strong
                >DATATEX EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES CONCERNING
                THIS SOFTWARE AND DOCUMENTATION, INCLUDING ANY WARRANTIES OF
                MERCHANTABILITY AND/OR FITNESS FOR ANY PARTICULAR PURPOSE,
                WARRANTIES OF PERFORMANCE, AND ANY WARRANTY THAT MIGHT OTHERWISE
                ARISE FROM THE COURSE OF DEALING OR USAGE OF TRADE. NO WARRANTY
                IS EITHER EXPRESS OR IMPLIED WITH RESPECT TO THE USE OF THE
                SOFTWARE OR DOCUMENTATION.</strong
              >
            </p>
            <p>
              Under no circumstances shall Datatex be liable for incidental,
              special, indirect, direct or consequential damages or loss of
              profits, interruption of business, or related expenses which may
              arise from use of software or documentation, including but not
              limited to those resulting from defects in software and/or
              documentation, or loss or inaccuracy of data of any kind whether
              or not Datatex had advance notice of the possibility of such
              damages.
            </p>
            <p>
              THE USER ASSUMES FULL RESPONSIBILITY FOR ITS SELECTION OF THE
              PRODUCTS SPECIFIED HEREIN AND ANY OTHER EQUIPMENT, PROGRAMS OR
              SERVICES USED WITH THE PRODUCTS, THEIR USE, AND RESULTS OBTAINED
              THERE FROM.
            </p>
            <p><strong>Refunds</strong></p>
            <p>
              You have 30 days to evaluate the software before registration and
              payment is required. Thereafter no refunds will be given under any
              circumstances.
            </p>
            <p>
              Software is downloaded from our website. There is no need for a
              delivery policy.
            </p>
            <p>
              Security Virtual Card Services process all credit card
              transactions. All credit card transactions are 128 bit Secure
              Socket Layers (SSL) encrypted. The company registration documents
              and the site’s registered domain name are checked and verified by
              Thawte, ensuring the cardholder and merchant that nobody can
              impersonate VCS to obtain confidential information. Virtual Card
              Services is committed to providing secure online services. All
              encryption complies with international standards. Encryption is
              used to protect the transmission of personal information when
              completing online transactions. Virtual Card Services Internet
              servers are protected by firewalls and intrusion detection
              systems. The Merchant does not have access to credit details.
              Virtual Card Services continually reviews and enhances its
              security in line with technological changes.
            </p>
            <p><strong>Monitoring</strong></p>
            <p>
              We have the right, but not the obligation, to monitor any activity
              and content associated with the Website. We may investigate any
              reported violation of these Conditions or complaints and take any
              action that we deem appropriate (which may include, but is not
              limited to, issuing warnings, suspending, terminating or attaching
              conditions to your access and/or removing any materials from the
              Website).
            </p>
            <p><strong>Law</strong></p>
            <p>
              The Conditions will be exclusively governed by and construed in
              accordance with the laws of South Africa whose Courts will have
              exclusive jurisdiction in any dispute, save that we have the
              right, at our sole discretion, to commence and pursue proceedings
              in alternative jurisdictions.
            </p>
            <p><strong>Use of Site</strong></p>
            <p>
              You may only use this site to browse the content, make legitimate
              purchases and shall not use this site for any other purposes,
              including without limitation, to make any speculative, false or
              fraudulent purchase. This site and the content provided in this
              site may not be copied, reproduced, republished, uploaded, posted,
              transmitted or distributed. ‘Deep-linking’, ’embedding’ or using
              analogous technology is strictly prohibited. Unauthorized use of
              this site and/or the materials contained on this site may violate
              applicable copyright, trademark or other intellectual property
              laws or other laws.
            </p>
            <p><strong>Disclaimer of Warranty</strong></p>
            <p>
              The contents of this site are provided “as is” without warranty of
              any kind, either expressed or implied, including but not limited
              to warranties of merchantability, fitness for a purpose and
              non-infringement.
            </p>
            <p>
              The owner of this site, the authors of these contents and in
              general anybody connected to this site in any way, from now on
              collectively called “Providers”, assume no responsibility for
              errors or omissions in these contents.
            </p>
            <p>
              The Providers further do not warrant, guarantee or make any
              representation regarding the safety, reliability, accuracy,
              correctness or completeness of these contents. The Providers shall
              not be liable for any direct, indirect, general, special,
              incidental or consequential damages (including -without
              limitation- data loss, lost revenues and lost profit) which may
              result from the inability to use or the correct or incorrect use,
              abuse, or misuse of these contents, even if the Providers have
              been informed of the possibilities of such damages. The Providers
              cannot assume any obligation or responsibility.
            </p>
            <p>
              The use of these contents is forbidden in those places where the
              law does not allow this disclaimer to take full effect.
            </p>
            <p><strong>Our Rights</strong></p>
            <p>
              We reserve the right to: modify or withdraw, temporarily or
              permanently, the Website (or any part of) with or without notice
              to you and you confirm that we shall not be liable to you or any
              third party for any modification to or withdrawal of the Website;
              and/or change these Conditions from time to time, and your
              continued use of the Website (or any part of) following such
              change shall be deemed to be your acceptance of such change. It is
              your responsibility to check regularly to determine whether the
              Conditions have been changed. If you do not agree to any change to
              the Conditions then you must immediately stop using the Website.
              We will use our reasonable endeavours to maintain the Website. The
              Website is subject to change from time to time. You will not be
              eligible for any compensation because you cannot use any part of
              the Website or because of a failure, suspension or withdrawal of
              all or part of the Website due to circumstances beyond our
              control.
            </p>
            <p><strong>Privacy Policy</strong></p>
            <p>
              We are committed to protecting your privacy. This privacy policy
              applies to all the web pages related to this website.
            </p>
            <p>
              All the information gathered in the online forms on the website is
              used to personally identify users that subscribe to this service.
              The information will not be used for anything other that which is
              stated in the Terms &amp; Conditions of use for this service. None
              of the information will be sold or made available to anyone.
            </p>
            <p>
              The Site may collect certain information about your visit, such as
              the name of the Internet service provider and the Internet
              Protocol (IP) address through which you access the Internet; the
              date and time you access the Site; the pages that you access while
              at the Site and the Internet address of the Web site from which
              you linked directly to our site. This information is used to help
              improve the Site, analyze trends, and administer the Site.
            </p>
            <p>
              We may need to change this policy from time to time in order to
              address new issues and reflect changes on our site. We will post
              those changes here so that you will always know what information
              we gather, how we might use that information, and whether we will
              disclose that information to anyone. Please refer back to this
              policy regularly. If you have any questions or concerns about our
              privacy policy, please send us an E-mail.
            </p>
            <p>
              By using this website, you signify your acceptance of our Privacy
              Policy. If you do not agree to this policy, please do not use our
              site. Your continued use of the website following the posting of
              changes to these terms will mean that you accept those changes.
            </p>
            <p><strong>Cookie/Tracking Technology</strong></p>
            <p>
              The Site may use cookie and tracking technology depending on the
              features offered. Cookie and tracking technology are useful for
              gathering information such as browser type and operating system,
              tracking the number of visitors to the Site, and understanding how
              visitors use the Site. Cookies can also help customize the Site
              for visitors. Personal information cannot be collected via cookies
              and other tracking technology; however, if you previously provided
              personally identifiable information, cookies may be tied to such
              information. Aggregate cookie and tracking information may be
              shared with third parties.
            </p>
            <p><strong>Third Party Links </strong></p>
            <p>
              In an attempt to provide increased value to our Users, we may
              provide links to other websites or resources. You acknowledge and
              agree that we are not responsible for the availability of such
              external sites or resources, and do not endorse and are not
              responsible or liable, directly or indirectly, for the privacy
              practices or the content (including misrepresentative or
              defamatory content) of such websites, including (without
              limitation) any advertising, products or other materials or
              services on or available from such websites or resources, nor for
              any damage, loss or offence caused or alleged to be caused by,or
              in connection with, the use of or reliance on any such content,
              goods or services available on such external sites or resources.
            </p>
            <button class="close-button" @click="closeModal">Close</button>
          </div>
        </div>
      </div>

      <!-- Promotion of Access to Information Act Modal -->
      <div
        v-if="showPromotionModal"
        class="modal-overlay"
        @click.self="closeModal"
      >
        <div class="modal-content">
          <h3>Promotion of Access to Information Act (PAIA) Forms</h3>
          <br />
          <div
            class="scroll-container"
            @scroll="onScroll('promotion')"
            style="max-height: 50vh"
          >
            <div class="entry-content clearfix">
              <div class="datatex-row-padding">
                <ul>
                  <li>
                    The
                    <a
                      href="https://www.gov.za/documents/promotion-access-information-act"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Promotion of Access to Information Act</a
                    >
                    2 of 2000 (commonly known as PAIA) is South Africa’s access
                    to information law.
                  </li>
                  <br />
                  <div id="side-2" class="datatex-paia">
                    <li> 
                      PAIA Manual:
                      <a
                        href="/PAIA Manual.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Access to information manual</a
                      >
                    </li>
                    <br />
                    <li>
                      Form 02:
                      <a
                        href="/Form 02 - Request for Access to Record.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Request for Access to Record</a
                      >
                      [Regulation 7]
                    </li>
                    <br />
                    <li>
                      Form 03:
                      <a
                        href="/Form 03 - Outcome of request and of fees payable.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Outcome of request and of fees payable</a
                      >
                      [Regulation 8]
                    </li>
                  </div>
                </ul>
              </div>
            </div>
            <button class="close-button" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      showTermsModal: false,
      showPromotionModal: false,
      termsScrollProgress: 0,
      promotionScrollProgress: 0,
    };
  },
  methods: {
    openModal(modalName) {
      this.showTermsModal = false;
      this.showPromotionModal = false;
      if (modalName === "terms") {
        this.showTermsModal = true;
      } else if (modalName === "promotion") {
        this.showPromotionModal = true;
      }
    },
    closeModal() {
      this.showTermsModal = false;
      this.showPromotionModal = false;
    },
    onScroll(modalName) {
      let scrollContainer = null;
      if (modalName === "terms") {
        scrollContainer = this.$el.querySelectorAll(
          ".modal-overlay .scroll-container"
        )[1];
        if (scrollContainer) {
          this.termsScrollProgress =
            (scrollContainer.scrollTop /
              (scrollContainer.scrollHeight - scrollContainer.clientHeight)) *
            100;
        }
      } else if (modalName === "promotion") {
        scrollContainer = this.$el.querySelectorAll(
          ".modal-overlay .scroll-container"
        )[2];
        if (scrollContainer) {
          this.promotionScrollProgress =
            (scrollContainer.scrollTop /
              (scrollContainer.scrollHeight - scrollContainer.clientHeight)) *
            100;
        }
      }
    },
  },
};
</script>

<style scoped>
.new_footer_area {
  background: white;
}

.new_footer_top {
  padding: 10px 0px 270px;
  position: relative;
  overflow-x: hidden;
}
.new_footer_area .footer_bottom {
  padding-top: 10px;
  padding-bottom: 15px;
}
.footer_bottom {
  background-color: #2c4a66;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  color: white;
  padding: 27px 0px;
}

/*************footer End*****************/

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content h3 {
  color: #2c4a66;
  border-bottom: #000 solid 3px;
}

.modal-content a {
  color: #2c4a66;
  text-decoration: none;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  color: black;
  padding: 20px;
  border-radius: 10px;
  width: 800px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: visible;
}

.scroll-container {
  overflow-y: auto;
  padding-right: 10px;
  position: relative;
  flex-grow: 1;
  scrollbar-width: thin;
  scrollbar-color: #2c4a66 #e0e0e0;
}

/* Custom scrollbar for WebKit browsers */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background-color: #2c4a66;
  border-radius: 10px;
  border: 2px solid #e0e0e0;
}

/* Fading edges */
.scroll-container::before,
.scroll-container::after {
  content: "";
  position: sticky;
  left: 0;
  right: 0;
  height: 20px;
  pointer-events: none;
  z-index: 10;
}

.scroll-container::before {
  top: 0;
  background: linear-gradient(to bottom, white, transparent);
}

.scroll-container::after {
  bottom: 0;
  background: linear-gradient(to top, white, transparent);
}

/* Scroll progress bar */
.scroll-progress {
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  background-color: #2c4a66;
  border-radius: 2px;
  transition: height 0.2s ease;
}

.close-button {
  margin-top: 20px;
  background-color: #2c4a66;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.close-button:hover {
  background-color: #1f3550;
}

.footer-main {
  background-color: #2c4a66;
  color: white;
  padding: 10px 20px;
  font-size: 15px;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.footer-right {
  text-align: right;
}

.footer-link {
  color: #999;
  text-decoration: none;
  font-size: 13px;
  margin-left: 20px;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  transition: 0.3s ease-in-out;
}
.footer-link:hover {
  color: #ddd;
}

/* Responsive styles */
@media (max-width: 600px) {
  .footer-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-right {
    text-align: left;
    margin-top: 10px;
  }
  .footer-link {
    margin-left: 0;
    font-size: 14px;
  }
  .footer-main {
    font-size: 14px;
    padding: 15px 10px;
  }
  .modal-content {
    width: 360px;
    height: 430px;
    margin-top: 75px;
  }
}
</style>
